import React from "react";
import { useParams } from "react-router-dom";
import { blogPosts } from "../../assets/BlogData/BlogData";
import { slugify } from "../Utils/Slugify";
import "./BlogPostPage.css"
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const BlogPostPage = () => {
  const { slug } = useParams();
  const blog = blogPosts.find((b) => slugify(b.title) === slug);

  if (!blog) return <h2>Blog not found</h2>;

  return (
    <div className="blog-post-page">
        <div className="blog-post-container">
            
            <h1>{blog.title}</h1>
            <p className="blog-description">{blog.description}</p>
            <img src={blog.image} alt={blog.title} className="blog-post-image" />
            <div className="blog-markdown">
                <ReactMarkdown remarkPlugins={[remarkGfm]}>{blog.content}</ReactMarkdown>
            </div>
        </div>
    </div>
  );
};

export default BlogPostPage;